module.exports = __webpack_public_path__ + "static/media/iconSend.f151f648.svg";